export enum QueryType {
    preSaleProduct = 'preSaleProduct',
    labelProduct = 'labelProduct',
    extendProduct = 'extendProduct',
    newProduct = 'newProduct',
    hotProduct = 'hotProduct'
}